import { render, staticRenderFns } from "./SettingsSidebar.vue?vue&type=template&id=72fced88&scoped=true"
import script from "./SettingsSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsSidebar.vue?vue&type=style&index=0&id=72fced88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fced88",
  null
  
)

export default component.exports